var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-wrapper" },
    [
      _c("div", { staticClass: "__second-title" }, [
        _vm._v(_vm._s(_vm.$t("walletQuota.list.title")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "total" }, [
        _vm._v(
          _vm._s(_vm.$t("walletQuota.list.total", { amount: _vm.totalAmount }))
        )
      ]),
      _vm._v(" "),
      _c(
        "wallet-table",
        {
          staticClass: "wallet-quota-table",
          attrs: {
            headList: _vm.headList,
            contentList: _vm.pledgeList,
            clickCell: _vm.clickCell
          }
        },
        [
          _vm._l(_vm.pledgeList, function(item, i) {
            return _c(
              "div",
              {
                key: i,
                attrs: { slot: i + "addrBefore" },
                slot: i + "addrBefore"
              },
              [
                _c("span", { staticClass: "beneficial-addr" }, [
                  _vm._v(_vm._s(_vm._f("shortAddr")(item.beneficialAddr, 8)))
                ]),
                _vm._v(" "),
                item.beneficialAddr === _vm.address
                  ? _c("span", { staticClass: "beneficial-img" })
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.pledgeList, function(item, i) {
            return _c(
              "span",
              {
                key: i,
                class: {
                  cancel: true,
                  active: item.isMaturity && !item.agent
                },
                attrs: { slot: i + "cancelBefore" },
                slot: i + "cancelBefore"
              },
              [_vm._v(_vm._s(_vm.$t("walletQuota.withdrawalStaking")))]
            )
          }),
          _vm._v(" "),
          _c("pagination", {
            staticClass: "__tb_pagination",
            attrs: {
              slot: "tableBottom",
              currentPage: _vm.currentPage + 1,
              totalPage: _vm.totalPage,
              toPage: _vm.toPage
            },
            slot: "tableBottom"
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("cancel-quota-stake", { ref: "cancelQuotaStake" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }